import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { AppModel } from 'walden-trace-app/routes/app';
import type UserService from 'walden-trace-app/services/user';

export default class AppController extends Controller {
  declare model: AppModel;

  @service('user') declare userService: UserService;

  @tracked
  isNavigationOpen = false;

  @action
  toggleNavigation() {
    this.isNavigationOpen = !this.isNavigationOpen;
  }

  @action
  logout() {
    this.userService.logout();
  }

  get userName() {
    const user = this.model.user;

    return user ? `${user.firstName} ${user.lastName}` : '?';
  }
}
